moya.lcalc = {
	init: function () {
		$('#lcalcCalculator').find('select').on('change', moya.lcalc.calculate).trigger('change');
	},
	compare: function (event) {
		var $target = $(event.target),
			$form = $target.parents('form');

		if ($target.attr('disabled') === 'disabled') {
			return false;
		}

		$.ajax({
			method: 'post',
			url: '/_/moya/lcalc/ajax/addCompare',
			data: {
				itemId: $form.find('#itemId').val(),
				priceId: $form.find('select[name="price"]').val(),
				includeId: $form.find('select[name="included"]').val(),
				insuranceId: $form.find('select[name="insurance"]').val(),
			}
		}).done(function() {
			$form.find('.item__compare').addClass('hidden');
			$form.find('.compareOpen').removeClass('hidden');

			$.ajax({
				url: '/_/moya/lcalc/ajax/refreshCompareButton'
			}).done(function(r) {
				$('#lcalcCompare').replaceWith(r);
			});
		}).error(function(err) {
			try {
				console.warn('Error while trying to add to compare', JSON.parse(err.responseText));
			}
			catch (e) {}
		});

		return false;
	},
	compareRemove: function(event) {
		var $target = $(event.target),
			$column = $target.parents('.column'),
			index = $column.attr('rel');

		$.ajax({
			method: 'post',
			url: '/_/moya/lcalc/ajax/removeCompare',
			data: {
				index: index
			}
		}).done(function() {
			$column.remove();
		});

		return false;
	},
	calculate: function (event) {
		var $target = $(event.target),
			$form = $target.parents('form'),
			valid = true,
			price = 0;

		$form.find('select').each(function () {
			var $this = $(this),
				$selected = $this.find(':selected'),
				increase = parseInt($selected.data('price'));

			if ($selected.val() < 1) {
				valid = false;
			}

			if (increase > 0) {
				price += increase;
			}
		});

		$form.find('.compareOpen').addClass('hidden');
		$form.find('.item__compare').removeClass('hidden');

		if (!valid) {
			$form.find('a, input[type="submit"]').attr('disabled', 'disabled');
		} else {
			$form.find('a, input[type="submit"]').removeAttr('disabled');
		}

		if (price > 0) {
			price = moya.lcalc.number_format(price, 0, ',', '.');
			$form.find('.item__price').html(price + '<span> kr. á mánuði með vsk.</span>');
		} else {
			$form.find('.item__price').html('-');
		}
	},
	number_format: function (number, decimals, decPoint, thousandsSep) {
		number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
		var n = !isFinite(+number) ? 0 : +number;
		var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
		var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
		var dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
		var s = '';

		var toFixedFix = function (n, prec) {
			if (('' + n).indexOf('e') === -1) {
				return +(Math.round(n + 'e+' + prec) + 'e-' + prec)
			} else {
				var arr = ('' + n).split('e');
				var sig = '';
				if (+arr[1] + prec > 0) {
					sig = '+'
				}
				return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec);
			}
		};

		s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.');
		if (s[0].length > 3) {
			s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
		}
		if ((s[1] || '').length < prec) {
			s[1] = s[1] || '';
			s[1] += new Array(prec - s[1].length + 1).join('0');
		}

		return s.join(dec);
	}
};
